import React, { useEffect, useState } from 'react'

import Alert from 'components_new/atoms/Alert'
import Button from 'components_new/atoms/Button'
import TextField from 'components_new/atoms/TextField'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import { CustomEndpoint } from 'types/GlobalCustomEndpoint'
import { TCustomEndpointLabels } from 'utils/sources'

interface EditEndpointDialogProps {
  /** The dialog is open while this is set. */
  endpoint: CustomEndpoint | null
  labels: TCustomEndpointLabels
  onClose: () => void
  onSubmit: (tableName: string, callback: (err?: boolean) => void) => void
}

/**
 * Renames the Homepal table an endpoint lands in. The technical name is
 * what the source is asked for and stays as it is; drop and re-add to
 * change that.
 */
const EditEndpointDialog = (props: EditEndpointDialogProps) => {
  const { endpoint, labels, onClose, onSubmit } = props

  const [tableName, setTableName] = useState('')
  const [failed, setFailed] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (endpoint) {
      setTableName(endpoint.attributes.table_name)
      setFailed(false)
      setSaving(false)
    }
  }, [endpoint])

  const trimmed = tableName.trim()
  const unchanged = trimmed === endpoint?.attributes.table_name

  const handleSubmit = () => {
    setFailed(false)
    setSaving(true)

    onSubmit(trimmed, (err) => {
      setSaving(false)

      if (err) {
        setFailed(true)
      } else {
        onClose()
      }
    })
  }

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={onClose} variant="text">
            Avbryt
          </Button>
          <Button
            disabled={!trimmed || unchanged}
            loading={saving}
            onClick={handleSubmit}
            variant="contained"
          >
            Spara
          </Button>
        </>
      }
      onClose={onClose}
      open={Boolean(endpoint)}
      title={endpoint?.attributes.technical_name ?? ''}
    >
      <TextField
        fullWidth={true}
        label={labels.corresponding}
        onChange={(event) => setTableName(event.target.value)}
        value={tableName}
      />

      {failed ? (
        <Alert severity="error">
          {`Kunde inte spara. Kontrollera att ${labels.corresponding.toLowerCase()} inte redan används.`}
        </Alert>
      ) : null}
    </SimpleDialog>
  )
}

export default EditEndpointDialog
